import React, { PureComponent, memo } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Tabs, Tab, Row, Col, Container } from "react-bootstrap";
import moment from "moment";
import { Obtener_Estado_Active_Directory_Request } from '../../../request/ParametroRequest';
import TabDetalles from "./tabDetalles.jsx";
import TabSucursales from "./tabSucursales.jsx";
import ModalSeguridad from "../../Seguridad/ModalSeguridad.jsx";

import {
    Zona_Agregar,
    Zona_Detalle,
    Zona_Modificar,
    SucursalesZona_Lista,
    Obtener_Sucursales_Lista,
    ListaSucursalesPorZonaGuardar,
} from "../../../request/MantenimientosRequest";

import { Obtener_MenuOpciones } from "../../../request/MenuRequest";
import { Obtener_CallCenter_Empresa_Request } from "../../../request/ParametroRequest";

import { SiteRutas } from "../../../request/RutasConfig";
import { Notificacion } from "../../../components/Util/Notificacion/Notificacion";

class zonasMantenimiento extends PureComponent {
    _isMounted = false;

    state = {
        activoAD: false,
        Datos: {
            Emp_Id: {
                value: 0,
                attributes: {
                    readOnly: true,
                    focus: false,
                    hidden: "none",
                    label: ""
                }
            },
            Id: {
                value: 0,
                attributes: {
                    readOnly: true,
                    focus: false,
                    hidden: "unset",
                    label: "Código:"
                }
            },
            CC_id: {
                value: 0,
                attributes: {
                    readOnly: false,
                    focus: false,
                    hidden: "unset",
                    label: "Call Center:"
                }
            },
            Nombre: {
                value: "",
                attributes: {
                    readOnly: false,
                    focus: false,
                    hidden: "unset",
                    label: "Descripción:",
                    maxLength: 35
                }
            },
            Detalle: {
                value: "",
                attributes: {
                    readOnly: false,
                    focus: false,
                    hidden: "unset",
                    label: "Detalle:",
                    maxLength: 250
                }
            },
            HoraInicio: {
                value: new Date("1900-01-01 00:00:00.000"),
                attributes: {
                    readOnly: false,
                    focus: false,
                    hidden: "unset",
                    label: "Inicio:"
                }
            },
            HoraFinal: {
                value: new Date("1900-01-01 23:59:59.000"),
                attributes: {
                    readOnly: false,
                    focus: false,
                    hidden: "unset",
                    label: "Final:"
                }
            },
            Sucursal: {
                value: "",
                attributes: {
                    readOnly: false,
                    focus: false,
                    hidden: "unset",
                    label: "Sucursal:"
                }
            }
        },
        titulo: "",
        listaSucursales: [],
        selectedSucursal: null,
        Id: 0,
        CC_id: 0,
        listaCallCenter: [],
        listaSucursalesZona: [],
        columnasSucursalesZona: [
            {
                dataField: "Suc_id",
                text: "Id",
                hidden: false,
                sort: false,
                editable: false
            },
            {
                dataField: "Suc_Nombre",
                text: "Nombre",
                hidden: false,
                sort: false,
                editable: false
            },
            {
                dataField: "Zona_Orden",
                text: "Orden",
                hidden: false,
                sort: false,
                editable: false
            },
            {
                dataField: "CC_Id",
                text: "",
                hidden: true,
                sort: true,
                editable: false
            },
            {
                dataField: "Emp_id",
                text: "",
                hidden: true,
                sort: true,
                editable: false
            },
            {
                dataField: "Zona_id",
                text: "",
                hidden: true,
                sort: true,
                editable: false,
            }
        ],
        selectedSucursalZona: 0,
        tituloTab1: "",
        tituloTab2: "",
        menuId: 0,
        CadenaId: 0,
        menuOpciones: [],
        showModalSeguridad: false,
        opcionValidar: 0,
        opcionSeleccionada: 1,
        tabActivo: 1,
        paginaActual: 1,
        cantidadRegistrosPaginaTabla: 10
    };

    volverAtras = () => {
        let menuId = this.state.menuId;

        this.props.history.push({
            pathname: `${SiteRutas.Zonas}`,
            state: { menuId: menuId },
        });
    };

    cambiarTamanioPagina = (cantidad) => {
        this.setState({ cantidadRegistrosPaginaTabla: cantidad });
    }

    cambiarPagina = (pagina) => {
        this.setState({ paginaActual: pagina });
    }

    onChangeInput = (e) => {
        const { name, value } = e.target;

        let newAttributes = this.state.Datos[name].attributes;

        const Datos = Object.assign({}, this.state.Datos, {
            [name]: { value: value, attributes: newAttributes },
        });
        this.setState({ Datos });
    };

    validarDatos = () => {
        let Datos = this.state.Datos;

        if (Datos.Nombre.value.trim().length === 0) {
            Notificacion.error("Error: Debe ingresar el dato: Descripción");
            return false;
        }

        if (Datos.Nombre.value.trim().length > 35) {
            Notificacion.error("Error: Debe ingresar máximo 35 caracteres");
            return false;
        }

        if (Datos.CC_id.value == 0) {
            Notificacion.error("Error: Debe seleccionar el dato: Call Center");
            return false;
        }

        if (Datos.Detalle.value.trim().length == 0) {
            Notificacion.error("Error: Debe ingresar el dato: Detalle");
            return false;
        }

        if (Datos.Detalle.value.trim().length > 250) {
            Notificacion.error("Error: Debe máximo 250 caracteres");
            return false;
        }

        if (Datos.HoraInicio.value == null) {
            Notificacion.error("Error: Debe ingresar el dato: Inicio");
            return false;
        }

        if (Datos.HoraFinal.value == null) {
            Notificacion.error("Error: Debe ingresar el dato: Final");
            return false;
        }

        if (Datos.HoraInicio.value >= Datos.HoraFinal.value) {
            Notificacion.error("Error: Rangos de hora incorrectos");
            return false;
        }

        if (Datos.HoraFinal.value <= Datos.HoraInicio.value) {
            Notificacion.error("Error: Rangos de hora incorrectos");
            return false;
        }

        return true;
    };
    obtenerEstadoActiveDirectory = async () => {
        const response = await Obtener_Estado_Active_Directory_Request();
        if (response.Exitoso) {
            this.setState({ activoAD: response.Datos });
        }
        else {
            Notificacion.error(response.Mensaje);
        }
    };
    ingresarDatos = async () => {
        let Datos = { ...this.state.Datos };
        let CadenaId = this.state.CadenaId;

        if (this.validarDatos()) {
            const _id = Datos.Id.value;
            const CC_id = Datos.CC_id.value;
            const token = this.props.token;
            const empresa = this.props.empresa.Id;

            let resultado = null;
            if (_id > 0) {
                resultado = await Zona_Modificar(
                    token,
                    empresa,
                    CC_id,
                    _id,
                    Datos.Nombre.value,
                    Datos.Detalle.value,
                    moment(Datos.HoraInicio.value).format("YYYY-MM-DD HH:mm:ss"),
                    moment(Datos.HoraFinal.value).format("YYYY-MM-DD HH:mm:ss")
                );
            } else {
                resultado = await Zona_Agregar(
                    token,
                    empresa,
                    CC_id,
                    _id,
                    Datos.Nombre.value,
                    Datos.Detalle.value,
                    moment(Datos.HoraInicio.value).format("YYYY-MM-DD HH:mm:ss"),
                    moment(Datos.HoraFinal.value).format("YYYY-MM-DD HH:mm:ss")
                );
            }

            if (resultado.Exitoso) {
                if (_id > 0) {
                    Notificacion.success("Se actualizó la información con éxito ");
                } else {
                    Notificacion.success("Se almacenó la información con éxito");

                    let Id = resultado.Mensaje.split(":")[1];

                    Datos.Id.value = Id;
                    Datos.CC_id.attributes.readOnly = true;

                    let titulo = "Modificar Zona";

                    this._isMounted && this.setState({ Datos, titulo });

                    let response = await Obtener_Sucursales_Lista(
                        token,
                        empresa,
                        CadenaId
                    );

                    if (response.Exitoso) {
                        let listaSucursales = [
                            { value: 0, label: "Seleccione una opción" },
                        ];

                        response.Datos.forEach((item) => {
                            listaSucursales.push({ value: item.Id, label: item.Nombre });
                        });

                        this._isMounted &&
                            this.setState({
                                listaSucursales,
                                selectedSucursal: listaSucursales[0],
                            });
                    } else {
                        Notificacion.error(response.Mensaje);
                    }
                }
            } else {
                Notificacion.error("Error: " + resultado.Mensaje);
            }
        }
    };

    ingresarDatosSucursalesPorZona = async () => {
        let Datos = { ...this.state.Datos };
        let listaSucursalesZona = [...this.state.listaSucursalesZona];

        let response = await ListaSucursalesPorZonaGuardar(
            this.props.token,
            listaSucursalesZona,
            this.props.empresa.Id,
            Datos.CC_id.value,
            Datos.Id.value
        );

        if (response.Exitoso) {
            Notificacion.success("Se actualizó la información con éxito ");
        } else {
            Notificacion.error("Error: " + response.Mensaje);
        }
    };

    onChangeDate = (name, date) => {
        let newAttributes = this.state.Datos[name].attributes;

        let newDate = new Date(
            "1900-01-01 " +
            date.getHours().toString() +
            ":" +
            date.getMinutes().toString() +
            ":00"
        );

        const Datos = Object.assign({}, this.state.Datos, {
            [name]: {
                value: newDate,
                attributes: newAttributes,
            },
        });
        this._isMounted && this.setState({ Datos });
    };

    onSelectChanged = async (event) => {
        const { name, value, options, selectedIndex } = event.target;

        let newAttributes = this.state.Datos[name].attributes;
        const Datos = Object.assign({}, this.state.Datos, {
            [name]: { value: value, attributes: newAttributes },
        });

        if (this._isMounted) {
            this.setState({ Datos });
        }
    };

    onhandleSelectedOption = (selectedSucursal) => {
        this._isMounted && this.setState({ selectedSucursal });
    };

    getMax = (arr, prop) => {
        var max;
        for (var i = 0; i < arr.length; i++) {
            if (max == null || parseInt(arr[i][prop]) > parseInt(max[prop]))
                max = arr[i];
        }
        return parseInt(max[prop]) + 1;
    };

    onClickAgregar = (e) => {
        e.preventDefault();

        let Datos = { ...this.state.Datos };
        const selectedSucursal = this.state.selectedSucursal;
        let listaSucursalesZona = [...this.state.listaSucursalesZona];

        if (Datos.Id.value > 0) {
            if (selectedSucursal.value > 0) {
                let orden =
                    listaSucursalesZona.length > 0
                        ? this.getMax(listaSucursalesZona, "Zona_Orden")
                        : 1;

                let resultado = listaSucursalesZona.filter(
                    (item) => item.Suc_id == selectedSucursal.value
                );

                if (resultado.length == 0) {
                    listaSucursalesZona.push({
                        Emp_id: 0,
                        Suc_id: selectedSucursal.value,
                        Suc_Nombre: selectedSucursal.label,
                        CC_Id: 0,
                        Zona_id: 0,
                        Zona_Orden: orden,
                    });

                    Notificacion.success("Dato agregado exitosamente");

                    this._isMounted && this.setState({ listaSucursalesZona });
                } else {
                    Notificacion.error("La Sucursal ya fue asociada a la zona");
                }
            } else {
                Notificacion.error("Debe seleccionar una Sucursal");
            }
        } else {
            Notificacion.error("Debe seleccionar una Zona");
        }
    };

    onClickEliminar = () => {
        let listaSucursalesZona = [...this.state.listaSucursalesZona];
        let selectedSucursalZona = this.state.selectedSucursalZona;
        if (selectedSucursalZona) {
            listaSucursalesZona = listaSucursalesZona.filter(zona => zona.Zona_Orden != selectedSucursalZona);
            selectedSucursalZona = 0;

            Notificacion.success("Dato Eliminado exitosamente");

            for (var i = 0; i < listaSucursalesZona.length; i++) {
                listaSucursalesZona[i].Zona_Orden = (i + 1);
            }

            let paginaActual = this.state.paginaActual;
            if (paginaActual > 1 && ((paginaActual - 1) * this.state.cantidadRegistrosPaginaTabla) >= listaSucursalesZona.length) {
                paginaActual--;
            }

            this._isMounted && this.setState({ listaSucursalesZona, selectedSucursalZona, paginaActual });
        } else {
            Notificacion.error("Debe seleccionar una fila para eliminar");
        }
    };

    onRowClick = (selectedSucursalZona) => {
        this._isMounted && this.setState({ selectedSucursalZona });
    };

    onClickMoverArriba = () => {
        let listaSucursalesZona = [...this.state.listaSucursalesZona];
        let selectedSucursalZona = this.state.selectedSucursalZona;

        if (selectedSucursalZona) {
            if (listaSucursalesZona.length > 1 && selectedSucursalZona > 1) {

                const currentIndex = listaSucursalesZona.findIndex(zona => zona.Zona_Orden === selectedSucursalZona);
                listaSucursalesZona[currentIndex].Zona_Orden = listaSucursalesZona[currentIndex - 1].Zona_Orden;
                listaSucursalesZona[currentIndex - 1].Zona_Orden = selectedSucursalZona;

                listaSucursalesZona = listaSucursalesZona.sort(
                    (a, b) => parseInt(a.Zona_Orden) - parseInt(b.Zona_Orden)
                );

                this._isMounted && this.setState({ listaSucursalesZona, selectedSucursalZona });
            }
        } else {
            Notificacion.error("Debe seleccionar una fila.");
        }
    };

    onClickMoverAbajo = () => {
        let listaSucursalesZona = [...this.state.listaSucursalesZona];
        let selectedSucursalZona = this.state.selectedSucursalZona;

        if (selectedSucursalZona) {
            const currentIndex = listaSucursalesZona.findIndex(zona => zona.Zona_Orden === selectedSucursalZona);
            if (listaSucursalesZona.length > 1 && currentIndex + 1 < listaSucursalesZona.length) {

                listaSucursalesZona[currentIndex].Zona_Orden = listaSucursalesZona[currentIndex + 1].Zona_Orden;
                listaSucursalesZona[currentIndex + 1].Zona_Orden = selectedSucursalZona;

                listaSucursalesZona = listaSucursalesZona.sort(
                    (a, b) => parseInt(a.Zona_Orden) - parseInt(b.Zona_Orden)
                );

                this._isMounted &&
                    this.setState({ listaSucursalesZona, selectedSucursalZona });
            }
        } else {
            Notificacion.error("Debe seleccionar una fila.");
        }
    };

    handleTabClick = (id) => {
        let menuOpciones = this.state.menuOpciones;
        let resultado = menuOpciones.filter((item) => item.Opcion_Id == id);

        if (resultado.length > 0) {
            if (resultado[0].Validar) {
                this._isMounted &&
                    this.setState({
                        showModalSeguridad: true,
                        opcionValidar: resultado[0].Opcion_Id,
                        tabActivo: 1,
                    });
            } else {
                this._isMounted &&
                    this.setState({
                        tabActivo: id,
                    });
            }
        } else {
            this._isMounted &&
                this.setState({
                    showModalSeguridad: true,
                    opcionValidar: id,
                    tabActivo: 1,
                });
        }
    };

    onActionResultModal = (pValido) => {
        if (pValido) {
            const opcionValidar = this.state.opcionValidar;
            this.setState(
                {
                    showModalSeguridad: false,
                    opcionSeleccionada: opcionValidar,
                    opcionValidar: 0,
                },
                () => {
                    this._isMounted && this.setState({ tabActivo: opcionValidar });
                }
            );
        } else {
            this._isMounted && this.setState({ tabActivo: 1 });
        }
    };

    componentDidMount = async () => {
        this._isMounted = true;
        this.obtenerEstadoActiveDirectory();
        let Datos = { ...this.state.Datos };

        let menuId = 0;
        let CadenaId = 0;

        if (this.props.location.state) {
            menuId = this.props.location.state.menuId;
        }

        let menuOpciones = null;
        let tituloTab1 = "", tituloTab2 = "";

        if (menuId > 0) {
            let response = await Obtener_MenuOpciones(this.props.token, menuId);

            if (response.Exitoso) {
                menuOpciones = response.Datos;

                if (menuOpciones.length > 0) {
                    tituloTab1 = menuOpciones[0].Nombre;
                }

                if (menuOpciones.length > 1) {
                    tituloTab2 = menuOpciones[1].Nombre;
                }
            } else {
                Notificacion.error(response.Mensaje);
            }
        }

        this._isMounted && this.setState({ menuId, CadenaId, menuOpciones, tituloTab1, tituloTab2 });

        let Id = this.props.match.params.id;
        let CC_id = this.props.match.params.CC_id;
        let empresa = this.props.empresa.Id;
        let token = this.props.token;

        let titulo = Id > 0 ? "Modificar Zona" : "Nueva Zona";

        Datos.Emp_Id.value = empresa;

        let listaCallCenter = [{ Id: 0, Nombre: "Seleccione una opción" }];
        let response = await Obtener_CallCenter_Empresa_Request(token, empresa);
        if (response.Exitoso) {
            response.Datos.forEach((item) => {
                listaCallCenter.push({ Id: item.Id, Nombre: item.Nombre });
            });

            this._isMounted &&
                this.setState({
                    listaCallCenter,
                });
        } else {
            Notificacion.error(response.Mensaje);
        }

        Datos.CC_id.value = CC_id;

        if (Id > 0) {
            let DatosZona = await Zona_Detalle(token, empresa, CC_id, Id);
            if (DatosZona.Exitoso) {
                Datos.CC_id.attributes.readOnly = true;
                Datos.Id.value = DatosZona.Datos.Id;
                Datos.Nombre.value = DatosZona.Datos.Nombre;
                Datos.Detalle.value = DatosZona.Datos.Detalle;
                Datos.HoraInicio.value = new Date(DatosZona.Datos.HoraInicio);
                Datos.HoraFinal.value = new Date(DatosZona.Datos.HoraFinal);
            } else {
                Notificacion.error(DatosZona.Mensaje);
            }

            /* obtener datos de sucursales por zona */

            response = await SucursalesZona_Lista(token, empresa, CC_id, Id);
            if (response.Exitoso) {
                this._isMounted && this.setState({ listaSucursalesZona: response.Datos });
            } else {
                //Notificacion.error(response.Mensaje);
            }

            response = await Obtener_Sucursales_Lista(token, empresa, CadenaId);
            if (response.Exitoso) {
                let listaSucursales = [{ value: 0, label: "Seleccione una opción" }];
                response.Datos.forEach((item) => {
                    listaSucursales.push({ value: item.Id, label: item.Nombre });
                });

                this._isMounted && this.setState({ listaSucursales, selectedSucursal: listaSucursales[0] });
            } else {
                Notificacion.error(response.Mensaje);
            }
        }

        this._isMounted && this.setState({ titulo, Id, CC_id, Datos });
    };

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        const {
            titulo,
            Datos,
            listaCallCenter,
            listaSucursalesZona,
            columnasSucursalesZona,
            selectedSucursal,
            listaSucursales,
            tituloTab1,
            tituloTab2,
            showModalSeguridad,
            opcionValidar,
            menuId,
            tabActivo,
            paginaActual
        } = this.state;

        return (
            <div className="main">
                <Container>
                    <Row>
                        <Col>
                            <h1>{titulo}</h1>
                        </Col>
                    </Row>
                    <div className="content-bg">
                        <Tabs
                            defaultActiveKey={1}
                            activeKey={tabActivo}
                            id="CallCenterDetalle"
                            onSelect={this.handleTabClick}
                        >
                            <Tab eventKey="1" title={tituloTab1}>
                                <TabDetalles
                                    Datos={Datos}
                                    listaCallCenter={listaCallCenter}
                                    volverAtras={this.volverAtras}
                                    ingresarDatos={this.ingresarDatos}
                                    onChangeInput={this.onChangeInput}
                                    onChangeDate={this.onChangeDate}
                                    onSelectChanged={this.onSelectChanged}
                                />
                            </Tab>
                            <Tab
                                eventKey="2"
                                title={tituloTab2}
                                disabled={Datos.Id.value == 0 ? true : false}
                            >
                                <TabSucursales
                                    Datos={Datos}
                                    columnasSucursalesZona={columnasSucursalesZona}
                                    listaSucursalesZona={listaSucursalesZona}
                                    selectedSucursal={selectedSucursal}
                                    listaSucursales={listaSucursales}
                                    onhandleSelectedOption={this.onhandleSelectedOption}
                                    onClickAgregar={this.onClickAgregar}
                                    onClickEliminar={this.onClickEliminar}
                                    onRowClick={this.onRowClick}
                                    ingresarDatosSucursalesPorZona={this.ingresarDatosSucursalesPorZona}
                                    volverAtras={this.volverAtras}
                                    onClickMoverArriba={this.onClickMoverArriba}
                                    onClickMoverAbajo={this.onClickMoverAbajo}
                                    paginaActual={paginaActual}
                                    onPageChange={this.cambiarPagina}
                                    onSizePerPageChange={this.cambiarTamanioPagina}
                                />
                            </Tab>
                        </Tabs>
                    </div>
                </Container>
                <ModalSeguridad
                    token={this.props.token}
                    menuId={menuId}
                    opcionId={opcionValidar}
                    show={showModalSeguridad}
                    onActionResult={this.onActionResultModal}
                    onHide={() => this.setState({ showModalSeguridad: false })}
                    activoAD={this.state.activoAD}   
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.usuario.token,
        empresa: state.parametros.empresa
    };
};

export default connect(mapStateToProps)(withRouter(memo(zonasMantenimiento)));
